<template>
  <div>
    <b-row v-if="pages.length || (!showNoThing && !pages.length)">
      <b-col md="12">
        <h4 CLASS="mb-1">
          {{ $t("dashboard.pages-list") }}
        </h4>
      </b-col>
      <b-col
        v-for="(page,index) in pages"
        :key="'page'+index"
        md="4"
      >
        <page-card
          :page="page"
          :token-invalid="invalidPageIds.includes(page.id)"
        />
      </b-col>
    </b-row>
    <div
      v-if="showNoPages"
      class="d-flex justify-content-center flex-column align-items-center mb-3"
    >
      <b-card-title
        title-tag="h4"
        class="font-weight-bold mb-1 text-center mt-2"
      >
        {{ $t('dashboard.no-fb-pages') }}
      </b-card-title>
      <b-button
        :disabled="loading"
        class="btn-facebook"
        @click="authFacebook(false)"
      >
        <b-spinner
          v-if="loading"
          small
          class="mr-1"
        />
        <feather-icon
          icon="FacebookIcon"
          class="mr-50"
        />
        <span>{{ $t('page.add-new') }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import PageCard from '@/views/owner-fb/page/components/PageCard'
import {
  BRow, BCol, BButton, BCardTitle, BSpinner,
} from 'bootstrap-vue'
import AuthMixin from '@/views/auth/mixins/auth-mixin'

export default {
  name: 'FbPagesBox',
  components: {
    PageCard,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BSpinner,
  },
  mixins: [AuthMixin],
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
    showNoPages: {
      type: Boolean,
      default: false,
    },
    showNoThing: {
      type: Boolean,
      default: false,
    },
    invalidPageIds: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
